var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _class3, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { A } from '@ember/array';
import { assert } from '@ember/debug';
import { action, computed, set } from '@ember/object';
import { dependentKeyCompat } from '@ember/object/compat';
import { or } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/ember';
import allowDeprecatedOverrides from '@square/dashboard-utilities/utils/compat/allow-deprecated-overrides';
import Enum from '@square/dashboard-utilities/utils/enum';
import Feature from '@square/dashboard-utilities/utils/sub2/feature';
import { Feature as SaasSharedUiFeature, FeatureSetKey } from '@squareup/saas-shared-ui';
import { feature } from '@square/ember-features/macros';
import sub2 from '@square/dashboard-data/clients/sub2';
import { ExternalGetFutureSubscribedFeatureDiffRequest } from '@square/dashboard-protos/models/squareup/sub2/v3/external/external_subscription_service';
import { RoleType } from '@square/dashboard-protos/models/squareup/empermissions/displaypermissions/permissions';
import { toPascalCase } from '@square/dashboard-utilities/utils/string';
import { SubscriptionStatus } from '@square/dashboard-protos/models/squareup/sub2/common';
import { invalidateSubscriptionStates, refreshFeatureStatuses, refreshFeatureSetStatuses, featureResponseToFeatureMap, featureSetResponseToFeatureSetMap } from '@squareup/saas-shared-ui/utils';
import { AppointmentsFeatureId } from '@square/appointments-feature-upsell/types/features';
import { jsonGet } from '@square/dashboard-utilities/utils/xhr';
import environment from '@square/environment-utils/environment';
import { featurama } from '@squareup/dashboard-query/queries/featurama';
import { ActivationStatus } from '@squareup/shared-types-protos/squareup/featurama/feature_sets';

// copied from frontend/dashboard/app/models/squareup/sub2/data/subscription.js
export const Status = Enum.create(['INVALID', 'PENDING', 'FREE_TRIAL', 'FREE_TRIAL_PENDING_CANCELLATION', 'ACTIVE', 'ACTIVE_PENDING_CANCELLATION', 'CANCELED', 'DELINQUENT', 'IN_GRACE', 'FREE_TRIAL_NO_OBLIGATION', 'NO_OBLIGATION_FREE_TRIAL_EXPIRED', 'ACTIVE_PENDING_PAUSE', 'PAUSED', 'PRESALE']);

// This is copied from Roster/MDS. It's the priority order it uses to decide what feature status to return when there
// are multiple subscriptions to choose from. If the MDS version changes, this needs to be updated as well.
// https://git.sqcorp.co/projects/SQ/repos/java/browse/roster/src/main/java/com/squareup/roster/service/UserLookupUtil.java#52-63
const STATUS_PRIORITY_ORDER = [Status.ACTIVE, Status.FREE_TRIAL, Status.ACTIVE_PENDING_PAUSE, Status.ACTIVE_PENDING_CANCELLATION, Status.FREE_TRIAL_PENDING_CANCELLATION, Status.IN_GRACE, Status.FREE_TRIAL_NO_OBLIGATION, Status.NO_OBLIGATION_FREE_TRIAL_EXPIRED, Status.PAUSED, Status.DELINQUENT, Status.CANCELED, Status.PRESALE, Status.PENDING, Status.INVALID];

// This list should be kept in sync with ENABLED_FEATURE_STATUSES in
// app/helpers/computed_permissions_helper.rb.
export const ENABLED_FEATURE_STATUSES = [Status.ACTIVE, Status.ACTIVE_PENDING_CANCELLATION, Status.IN_GRACE, Status.FREE_TRIAL, Status.FREE_TRIAL_PENDING_CANCELLATION, Status.FREE_TRIAL_NO_OBLIGATION, Status.NO_OBLIGATION_FREE_TRIAL_EXPIRED, Status.ACTIVE_PENDING_PAUSE];
function getPojoFromFeatureStatus(featureStatus) {
  return {
    feature: featureStatus.feature,
    status: featureStatus.status,
    subscriptionToken: featureStatus.subscriptionToken
  };
}
let TrackedQueryResult = (_class = class TrackedQueryResult {
  constructor() {
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "isLoading", _descriptor2, this);
    _initializerDefineProperty(this, "isError", _descriptor3, this);
    _initializerDefineProperty(this, "isSuccess", _descriptor4, this);
  }
  update(result) {
    // When refetching after the first successful fetch, `isSuccess` is true
    // so we have to additionally check for `isFetching`. We do this to prevent
    // re-renders during this state.
    if (result.isSuccess && !result.isFetching && result.data) {
      this.data = result.data;
    }
    this.isLoading = result.isLoading;
    this.isError = result.isError;
    this.isSuccess = result.isSuccess;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isSuccess", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _class);
let UserSubscriptions = (_dec = feature('restaurants/use_rst_tiered_subscriptions'), _dec2 = feature('catalog/spos_sellers_can_use_gtins_by_default_dashboard'), _dec3 = feature('catalog/all_sellers_can_use_gtin_in_dashboard'), _dec4 = feature('square_one_web/featurama_calls_enabled'), _dec5 = feature('restaurants/override_kiosk_subscription'), _dec6 = computed('subscriptionFeatureStatus.@each.status', '_isMarketingPaused'), _dec7 = computed('_isSubscribedToLoyalty', 'canAccessSquareOne', 'featuramaFeatureStatusesResult.data', 'subscriptionFeatureStatus.@each.status'), _dec8 = computed('currentUserData.data.canSeeBasicRestaurantsFeatures', '_isRestaurantsUser', 'squareOneEligible', 'featureSetStatusMap'), _dec9 = computed('_isSubscribingToRetail'), _dec10 = computed('_isSubscribedToRetailPlus', 'subscriptionFeatureStatus.@each.status'), _dec11 = computed('subscriptionFeatureStatus.[]', '_isSubscribedToRetail'), _dec12 = computed('_canRetailerSeeItemOptions', 'isSubscribedToRetailPlus'), _dec13 = computed('_isRetailFreeTrialNoObligation', 'subscriptionFeatureStatus.@each.status'), _dec14 = computed('_isRetailFreeTrial', 'subscriptionFeatureStatus.@each.status'), _dec15 = computed('_isRetailFree', 'subscriptionFeatureStatus.@each.status'), _dec16 = computed('_isRetailPaused', 'subscriptionFeatureStatus.@each.status'), _dec17 = computed('subscriptionFeatureStatus.@each.status'), _dec18 = computed('subscriptionFeatureStatus.@each.status'), _dec19 = computed('subscriptionFeatureStatus.@each.status'), _dec20 = computed('subscriptionFeatureStatus.@each.status'), _dec21 = computed('_canUseAdvancedInventory', 'currentUserData.data.shouldSeeAdvancedInventory', 'subscriptionFeatureStatus.@each.status', 'canUseRecipes'), _dec22 = computed('_canSeeGtinFeatures', 'canAllSellersUseGtin', 'canSposSellersUseGtinsByDefault', 'currentUserData.data.shouldSeeAdvancedInventory', 'isRestaurantsUser', 'isSubscribedToAppointments', 'subscriptionFeatureStatus.@each.status'), _dec23 = computed('_isSubscribingToRestaurants'), _dec24 = computed('_isRestaurantsFreeTrialNoObligation', 'isNewTierRestaurantsTrialNoObligation', 'isRestaurantsPlusTrialNoObligation', 'isRestaurantsPremiumTrialNoObligation', 'subscriptionFeatureStatus.@each.status'), _dec25 = computed('isRestaurantsPlusTrialNoObligation', 'isRestaurantsPremiumTrialNoObligation', 'subscriptionFeatureStatus.@each.status'), _dec26 = computed('subscriptionFeatureStatus.@each.status'), _dec27 = computed('subscriptionFeatureStatus.@each.status'), _dec28 = computed('subscriptionFeatureStatus.@each.status'), _dec29 = computed('subscriptionFeatureStatus.@each.status'), _dec30 = computed('subscriptionFeatureStatus.@each.status'), _dec31 = computed('subscriptionFeatureStatus.@each.status'), _dec32 = computed('isSubscribedToRestaurantsFree', 'isSubscribedToRestaurantsPlus', 'isSubscribedToRestaurantsPremium', 'subscriptionFeatureStatus.@each.status'), _dec33 = computed('_isSubscribedToCombos', 'subscriptionFeatureStatus.@each.status', 'featuramaFeatureStatusesResult.data', 'squareOneEligible'), _dec34 = computed('subscriptionFeatureStatus.@each.status'), _dec35 = computed('_isKDSFreeTrialNoObligation', 'isPayingRstSubscriber', 'isRestaurantsFreeTrialNoObligation', 'subscriptionFeatureStatus.@each.status'), _dec36 = computed('_isPayingRstSubscriber', 'isSubscribedToRestaurantsLegacy', 'subscriptionFeatureStatus.@each.status', 'useRstTieredSubscriptions'), _dec37 = computed('_isRestaurantsFreeTierUser', 'currentUserData.data.canSeeBasicRestaurantsFeatures', 'isNewRstFreeTierUser', 'isPayingRstSubscriber'), _dec38 = computed('subscriptionFeatureStatus.@each.status', 'useRstTieredSubscriptions', '_isNewRstFreeTierUser'), _dec39 = computed('_isSubscribedToRestaurantsLegacy', 'currentUserData.data.dashboardDataHasRestaurantsSubscriptionOverride', 'onboardedToRestaurantsPlus', 'rstFreeTrialJustStarted', 'subscriptionFeatureStatus.@each.status'), _dec40 = computed('currentUserData.data.canSeeBasicRestaurantsFeatures', 'isPayingRstSubscriber', 'isNewRstFreeTierUser'), _dec41 = computed('_isSubscribedToKDS', 'squareOneEligible', 'subscriptionFeatureStatus.@each.status', 'featureSetStatusMap', 'featuramaFeatureStatuses'), _dec42 = computed('_isSubscribedToFnbKiosk', 'overrideKioskSubscription', 'subscriptionFeatureStatus.@each.status'), _dec43 = computed('_wasSubscribedToFnbKiosk', 'subscriptionFeatureStatus.@each.status'), _dec44 = computed('subscriptionFeatureStatus.@each.status'), _dec45 = computed('subscriptionFeatureStatus.@each.status'), _dec46 = computed('subscriptionFeatureStatus.@each.status', 'wasSubscribedToNewPaidRestaurantTiers', 'wasSubscribedToRestaurantsLegacy'), _dec47 = computed('subscriptionFeatureStatus.@each.status'), _dec48 = or('isPayingRstSubscriber', 'wasSubscribedToRestaurants'), _dec49 = computed('subscriptionFeatureStatus.@each.status'), _dec50 = or('isPayingRstSubscriber', 'wasSubscribedToNewPaidRestaurantTiers'), _dec51 = computed('isOrWasSubscribedToRestaurants', 'squareOneEligible', 'featureSetStatusMap'), _dec52 = computed('_isSubscribedToEmployeeManagement', 'canAccessSquareOne', 'subscriptionFeatureStatus.@each.status', 'featuramaFeatureStatusesResult.data'), _dec53 = computed('_isSubscribedToAppointments', 'canAccessSquareOne', 'subscriptionFeatureStatus.[]', 'appointmentsActiveFeatures.[]'), _dec54 = computed('_wasSubscribedToEcomPlus', 'subscriptionFeatureStatus.@each.status'), _dec55 = computed('_isPayingEcomSubscriber', 'subscriptionFeatureStatus.@each.status'), _dec56 = computed('_canUseCategoryRollups', 'appointmentsActiveFeatures.[]', 'squareOneEligibleOrUnknown', 'isPayingRstSubscriber', 'subscriptionFeatureStatus.[]', 'featuramaFeatureStatusesResult.data'), _dec57 = computed('subscriptionFeatureStatus.[]', '_isSubscribedToBlockedBooking'), _dec58 = computed('featuramaFeatureStatusesResult.data'), _dec59 = computed('featureSetStatusResult.data'), _class3 = class UserSubscriptions extends Service {
  constructor(owner) {
    super(owner);
    _initializerDefineProperty(this, "currentUserData", _descriptor5, this);
    _initializerDefineProperty(this, "emberQuery", _descriptor6, this);
    _initializerDefineProperty(this, "features", _descriptor7, this);
    _initializerDefineProperty(this, "squareOneEligibility", _descriptor8, this);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor9, this);
    _initializerDefineProperty(this, "userInfo", _descriptor10, this);
    _initializerDefineProperty(this, "useRstTieredSubscriptions", _descriptor11, this);
    _initializerDefineProperty(this, "canSposSellersUseGtinsByDefault", _descriptor12, this);
    _initializerDefineProperty(this, "canAllSellersUseGtin", _descriptor13, this);
    _initializerDefineProperty(this, "featuramaCallsEnabled", _descriptor14, this);
    _initializerDefineProperty(this, "overrideKioskSubscription", _descriptor15, this);
    // it is expected for this to be undefined, updateSubscriptionFeatures() inits it to []
    _initializerDefineProperty(this, "subscriptionFeatureStatus", _descriptor16, this);
    _initializerDefineProperty(this, "appointmentsActiveFeatures", _descriptor17, this);
    _initializerDefineProperty(this, "hasLoadedFeaturamaFeatureFlag", _descriptor18, this);
    _initializerDefineProperty(this, "featureStatusesQueryObserver", _descriptor19, this);
    _initializerDefineProperty(this, "featureSetStatusesQueryObserver", _descriptor20, this);
    _defineProperty(this, "queryDefs", {
      bulkRetrieveFeatureStatuses: featurama.bulkRetrieveFeatureStatuses({
        includeActivationStatuses: true
      }),
      bulkRetrieveFeatureSetStatuses: featurama.bulkRetrieveFeatureSetStatuses()
    });
    _defineProperty(this, "_isMarketingPaused", void 0);
    _defineProperty(this, "_isSubscribedToLoyalty", void 0);
    _defineProperty(this, "_isRestaurantsUser", void 0);
    // Retail
    _defineProperty(this, "_isSubscribingToRetail", void 0);
    _defineProperty(this, "_isSubscribedToRetailPlus", void 0);
    _defineProperty(this, "_isSubscribedToRetail", void 0);
    _defineProperty(this, "_canRetailerSeeItemOptions", void 0);
    _defineProperty(this, "_isRetailFreeTrialNoObligation", void 0);
    _defineProperty(this, "_isRetailFreeTrial", void 0);
    _defineProperty(this, "_isRetailFree", void 0);
    _defineProperty(this, "_isRetailPaused", void 0);
    _defineProperty(this, "_canUseAdvancedInventory", void 0);
    _defineProperty(this, "_canSeeGtinFeatures", void 0);
    // Restaurants
    _defineProperty(this, "rstFreeTrialJustStarted", false);
    // deprecated
    _defineProperty(this, "onboardedToRestaurantsPlus", false);
    _defineProperty(this, "_isSubscribingToRestaurants", void 0);
    _defineProperty(this, "_isRestaurantsFreeTrialNoObligation", void 0);
    // COMBOS as a feature can be subscribed to as an individual add-on,
    // or as part of a paid RESTAURANTS tier or Square One plan.
    _defineProperty(this, "_isSubscribedToCombos", void 0);
    _defineProperty(this, "_isKDSFreeTrialNoObligation", void 0);
    _defineProperty(this, "_isPayingRstSubscriber", void 0);
    _defineProperty(this, "_isRestaurantsFreeTierUser", void 0);
    // rstFreeTrialJustStarted allows us to ensure the correct setup guide displays when refreshing immediately after
    // starting an rst trial and hard refreshing, which loses the in-memory subscription info
    //
    // also note: unlike isSubscribedToRetail or isSubscribedToAppointments, isSubscribedToRestaurantsLegacy only
    // captures paid restaurant subscribers, not free subscribers.
    //
    // NOTE: This is for the legacy `RESTAURANTS` sub2 feature. If looking for the new
    // RESTAURANTS_PLUS feature, use `isSubscribedToRestaurantsPlus`.
    // `isPayingRstSubscriber` encapsulates both legacy and new RST subscription tiers
    _defineProperty(this, "_isSubscribedToRestaurantsLegacy", void 0);
    _defineProperty(this, "_isSubscribedToKDS", void 0);
    _defineProperty(this, "_isSubscribedToFnbKiosk", void 0);
    _defineProperty(this, "_wasSubscribedToFnbKiosk", void 0);
    _initializerDefineProperty(this, "isOrWasSubscribedToRestaurants", _descriptor21, this);
    _initializerDefineProperty(this, "isOrWasSubscribedToNewPaidRestaurantsTiers", _descriptor22, this);
    // Team Management
    _defineProperty(this, "_isSubscribedToEmployeeManagement", void 0);
    _defineProperty(this, "_isSubscribedToAppointments", void 0);
    _defineProperty(this, "_hasAppointmentsAccount", void 0);
    // === END APPOINTMENTS ===
    // ECOM
    _defineProperty(this, "_isPayingEcomSubscriber", void 0);
    _defineProperty(this, "_wasSubscribedToEcomPlus", void 0);
    _defineProperty(this, "_isSubscribedToBlockedBooking", void 0);
    // === START SQUARE ONE ===
    _defineProperty(this, "featuramaFeatureStatusesResult", new TrackedQueryResult());
    _defineProperty(this, "featureSetStatusResult", new TrackedQueryResult());
    for (const feature of Object.values(SaasSharedUiFeature)) {
      this.defineFeatureGetters(feature);
    }
  }
  get shouldCallFeaturama() {
    return environment().isTesting || this.featuramaCallsEnabled;
  }
  setupFeatureStatusesQueryObservers() {
    if (!this.shouldCallFeaturama) {
      return;
    }
    this.featureStatusesQueryObserver ||= this.emberQuery.observeQuery(this.queryDefs.bulkRetrieveFeatureStatuses, this.setFeaturamaFeatureStatuses);
    this.featureSetStatusesQueryObserver ||= this.emberQuery.observeQuery(this.queryDefs.bulkRetrieveFeatureSetStatuses, this.setFeaturamaSetStatuses);
  }
  cleanUpFeatureStatusesQueryObservers() {
    this.featureStatusesQueryObserver?.();
    this.featureStatusesQueryObserver = undefined;
    this.featureSetStatusesQueryObserver?.();
    this.featureSetStatusesQueryObserver = undefined;
  }
  setFeaturamaFeatureStatuses(queryResult) {
    this.featuramaFeatureStatusesResult.update(queryResult);
  }
  setFeaturamaSetStatuses(queryResult) {
    this.featureSetStatusResult.update(queryResult);
  }
  get isSubscribedToMarketing() {
    return this.subscriptionFeatureIsEnabled(Feature.MARKETING);
  }
  get isSubscribedToMarketingSms() {
    return this.subscriptionFeatureIsEnabled(Feature.MARKETING_SMS);
  }
  get isMarketingPaused() {
    if (this._isMarketingPaused !== undefined) {
      return this._isMarketingPaused;
    }
    return this.subscriptionFeatureIsStatus(Feature.MARKETING, Status.PAUSED);
  }
  set isMarketingPaused(value) {
    set(this, '_isMarketingPaused', value);
  }
  get isSubscribedToLoyalty() {
    if (this._isSubscribedToLoyalty !== undefined) {
      return this._isSubscribedToLoyalty;
    }
    return this.canAccessSquareOne ? this.isEntitledToFeature(SaasSharedUiFeature.LOYALTY) : this.subscriptionFeatureIsEnabled(Feature.LOYALTY);
  }
  set isSubscribedToLoyalty(value) {
    set(this, '_isSubscribedToLoyalty', value);
  }
  get isRestaurantsUser() {
    if (this._isRestaurantsUser !== undefined) {
      return this._isRestaurantsUser;
    }
    if (this.squareOneEligible) {
      return this.isFeatureSetActive(FeatureSetKey.RESTAURANTS);
    }
    return this.currentUserData.data.canSeeBasicRestaurantsFeatures;
  }
  set isRestaurantsUser(value) {
    set(this, '_isRestaurantsUser', value);
  }
  async getAffectedEmployeesAfterPermissionsDowngrade({
    employees,
    requestTokens,
    permissionSets
  }) {
    const result = await sub2.externalGetFutureSubscribedFeatureDiff(ExternalGetFutureSubscribedFeatureDiffRequest.create(requestTokens));
    const resultToJSON = result.toJSON();
    const usedToHaveEmployeeManagement = resultToJSON.futureSubscribedFeatures?.includes(Feature.EMPLOYEE_MANAGEMENT);
    const usedToHaveCPS2 = resultToJSON.futureSubscribedFeatures?.includes(Feature.TEAM_MANAGEMENT_PERMISSION_SETS_BASIC);
    const stillHaveEmployeeManagement = resultToJSON.futureSubscribedFeaturesWithPlanChange?.includes(Feature.EMPLOYEE_MANAGEMENT) || false;
    const stillHaveCPS2 = resultToJSON.futureSubscribedFeaturesWithPlanChange?.includes(Feature.TEAM_MANAGEMENT_PERMISSION_SETS_BASIC) || false;
    let shouldFilterForExtra = false;
    let shouldFilterForCustom = false;
    if (usedToHaveEmployeeManagement && usedToHaveCPS2) {
      if (stillHaveCPS2 && !stillHaveEmployeeManagement) {
        shouldFilterForExtra = false;
        shouldFilterForCustom = true;
      } else if (!stillHaveCPS2 && !stillHaveEmployeeManagement) {
        shouldFilterForCustom = true;
        shouldFilterForExtra = true;
      }
    } else if (usedToHaveEmployeeManagement && !usedToHaveCPS2 && !stillHaveEmployeeManagement) {
      shouldFilterForExtra = false;
      shouldFilterForCustom = true;
    } else if (usedToHaveCPS2 && !usedToHaveEmployeeManagement && !stillHaveCPS2) {
      shouldFilterForExtra = true;
      shouldFilterForCustom = true;
    }
    return employees.filter(employee => {
      const permissionSet = permissionSets?.get(employee.employeeRole?.token || '');
      return shouldFilterForCustom && permissionSet?.roleType === RoleType.CUSTOM || shouldFilterForExtra && permissionSet?.roleType === RoleType.EXTRA;
    });
  }
  async refreshSubscriptionFeatures({
    refreshFeaturamaFeatures = true
  } = {}) {
    const promises = [];
    promises.push(async () => {
      const features = await sub2.externalListFeatureStatuses({});
      this.updateSubscriptionFeatures(this.toJsonFeatureStatuses(features.featureStatuses), {
        refreshFeaturamaFeatures: false
      });
    });
    if (refreshFeaturamaFeatures) {
      promises.push(() => this.refreshFeaturamaFeatures({
        // Don't circularly refresh sub2 features
        refreshSub2Features: false
      }).catch());
    }
    await Promise.allSettled(promises.map(promise => promise()));
  }
  async refreshFeatureSetStatuses() {
    await refreshFeatureSetStatuses(this.emberQuery.queryClientInstance);
  }
  async invalidateSquareOneSubscriptionStates(options) {
    await invalidateSubscriptionStates(this.emberQuery.queryClientInstance, options);
  }
  toJsonFeatureStatuses(featureStatuses) {
    return featureStatuses.map(({
      feature,
      status,
      subscriptionToken
    }) => ({
      feature: SaasSharedUiFeature[feature],
      status: SubscriptionStatus[status],
      subscriptionToken
    }));
  }
  async refreshFeaturamaFeatures({
    refreshSub2Features = true
  } = {}) {
    const promises = [];
    if (this.shouldCallFeaturama) {
      promises.push(refreshFeatureStatuses(this.emberQuery.queryClientInstance));
    }
    if (refreshSub2Features) {
      promises.push(this.refreshSubscriptionFeatures({
        // Don't circularly refresh featurama features
        refreshFeaturamaFeatures: false
      }));
    }
    await Promise.allSettled(promises);
  }
  updateSubscriptionFeatures(newFeatures, {
    refreshFeaturamaFeatures = true
  } = {}) {
    const subscriptionFeatureStatus = this.subscriptionFeatureStatus ? A([...this.subscriptionFeatureStatus]) : A();
    for (const newFeature of newFeatures.map(getPojoFromFeatureStatus)) {
      const existingFeature = subscriptionFeatureStatus.findBy('feature', newFeature.feature);
      const existingFeatureIndex = existingFeature ? subscriptionFeatureStatus.indexOf(existingFeature) : -1;

      // Add a feature that doesn't already exist
      if (!existingFeature) {
        subscriptionFeatureStatus.pushObject(newFeature);
        continue;
      }

      // Always update features with the same subscription token
      if (newFeature.subscriptionToken === existingFeature.subscriptionToken) {
        subscriptionFeatureStatus.replace(existingFeatureIndex, 1, [newFeature]);
        continue;
      }
      const existingFeaturePriorityOrder = STATUS_PRIORITY_ORDER.indexOf(existingFeature.status);
      const newFeaturePriorityOrder = STATUS_PRIORITY_ORDER.indexOf(newFeature.status);
      let shouldContinue = false;
      if (existingFeaturePriorityOrder === -1) {
        const error = `Existing feature ${existingFeature.feature} has invalid status "${existingFeature.status}"`;
        Sentry.captureException(new Error(error));
        shouldContinue = true;
        assert(error);
      }
      if (newFeaturePriorityOrder === -1) {
        const error = `Updated feature ${newFeature.feature} has invalid status "${newFeature.status}"`;
        Sentry.captureException(new Error(error));
        shouldContinue = true;
        assert(error);
      }
      if (shouldContinue) {
        continue;
      }

      // For features that already exist, respect the MDS priority - e.g. don't overwrite an active feature with an
      // inactive one. (This shouldn't normally happen, but when rolling out Loyalty on sub2 we had an issue that
      // required a rollback, and this makes it so the old package works if the new package is canceled.)
      if (existingFeaturePriorityOrder === -1 || newFeaturePriorityOrder < existingFeaturePriorityOrder) {
        subscriptionFeatureStatus.replace(existingFeatureIndex, 1, [newFeature]);
      }
    }
    set(this, 'subscriptionFeatureStatus', subscriptionFeatureStatus);
    const promise = Promise.resolve();
    if (refreshFeaturamaFeatures) {
      promise.then(() => {
        this.refreshFeaturamaFeatures({
          refreshSub2Features: false
        }).catch(() => {
          Sentry.captureException(new Error('Failed to refresh Featurama features'));
        });
      });
    }
    return promise;
  }
  getFeatureStatusSubscriptionToken(feature) {
    if (isEmpty(this.subscriptionFeatureStatus)) {
      return null;
    }
    const featureStatus = this.subscriptionFeatureStatus?.findBy('feature', feature);
    if (!featureStatus) {
      return null;
    }
    return featureStatus.subscriptionToken;
  }
  getSubscriptionFeatureStatus(feature) {
    if (isEmpty(this.subscriptionFeatureStatus)) {
      return null;
    }
    const featureStatus = this.subscriptionFeatureStatus?.findBy('feature', feature);
    if (!featureStatus) {
      return null;
    }
    return featureStatus.status;
  }
  subscriptionFeatureIsEnabled(feature) {
    const status = this.getSubscriptionFeatureStatus(feature);
    if (!status) {
      return false;
    }
    return ENABLED_FEATURE_STATUSES.includes(status);
  }
  subscriptionFeatureInFreeTrial(feature) {
    const status = this.getSubscriptionFeatureStatus(feature);
    if (!status) {
      return false;
    }
    return status === Status.FREE_TRIAL || status === Status.FREE_TRIAL_PENDING_CANCELLATION || status === Status.FREE_TRIAL_NO_OBLIGATION;
  }
  subscriptionFeatureIsStatus(feature, status) {
    return this.getSubscriptionFeatureStatus(feature) === status;
  }
  get isSubscribingToRetail() {
    return this._isSubscribingToRetail;
  }
  set isSubscribingToRetail(value) {
    set(this, '_isSubscribingToRetail', value);
  }
  get isSubscribedToRetailPlus() {
    if (this._isSubscribedToRetailPlus !== undefined) {
      return this._isSubscribedToRetailPlus;
    }
    return this.subscriptionFeatureIsEnabled(Feature.RETAIL);
  }
  set isSubscribedToRetailPlus(value) {
    set(this, '_isSubscribedToRetailPlus', value);
  }
  get isSubscribedToRetail() {
    if (this._isSubscribedToRetail !== undefined) {
      return this._isSubscribedToRetail;
    }
    return this.subscriptionFeatureStatus?.any(featureStatus => {
      return featureStatus.feature === Feature.RETAIL;
    }) ?? false;
  }
  set isSubscribedToRetail(value) {
    set(this, '_isSubscribedToRetail', value);
  }
  get isSubscribedToRetailFree() {
    return this.isSubscribedToRetail && !this.isSubscribedToRetailPlus;
  }
  get canRetailerSeeItemOptions() {
    if (this._canRetailerSeeItemOptions !== undefined) {
      return this._canRetailerSeeItemOptions;
    }
    return this.isSubscribedToRetailPlus;
  }
  set canRetailerSeeItemOptions(value) {
    set(this, '_canRetailerSeeItemOptions', value);
  }
  get isRetailFreeTrialNoObligation() {
    if (this._isRetailFreeTrialNoObligation !== undefined) {
      return this._isRetailFreeTrialNoObligation;
    }
    return this.subscriptionFeatureIsStatus(Feature.RETAIL, Status.FREE_TRIAL_NO_OBLIGATION);
  }
  set isRetailFreeTrialNoObligation(value) {
    set(this, '_isRetailFreeTrialNoObligation', value);
  }
  get isRetailFreeTrial() {
    if (this._isRetailFreeTrial) {
      return this._isRetailFreeTrial;
    }
    return this.subscriptionFeatureInFreeTrial(Feature.RETAIL);
  }
  set isRetailFreeTrial(value) {
    set(this, '_isRetailFreeTrial', value);
  }
  get isRetailFree() {
    if (this._isRetailFree !== undefined) {
      return this._isRetailFree;
    }
    return this.subscriptionFeatureIsStatus(Feature.RETAIL, Status.CANCELED);
  }
  set isRetailFree(value) {
    set(this, '_isRetailFree', value);
  }
  get isRetailPaused() {
    if (this._isRetailPaused) {
      return this._isRetailPaused;
    }
    return this.subscriptionFeatureIsStatus(Feature.RETAIL, Status.PAUSED);
  }
  set isRetailPaused(value) {
    set(this, '_isRetailPaused', value);
  }
  get isRetailDelinquent() {
    return this.subscriptionFeatureIsStatus(Feature.RETAIL, Status.DELINQUENT);
  }
  get isRetailFreeTrialExpired() {
    return this.subscriptionFeatureIsStatus(Feature.RETAIL, Status.NO_OBLIGATION_FREE_TRIAL_EXPIRED);
  }
  get isRetailPending() {
    return this.subscriptionFeatureIsStatus(Feature.RETAIL, Status.PENDING);
  }
  get isRetailPresale() {
    return this.subscriptionFeatureIsStatus(Feature.RETAIL, Status.PRESALE);
  }
  get canUseAdvancedInventory() {
    if (this._canUseAdvancedInventory) {
      return this._canUseAdvancedInventory;
    }
    // TODO: shouldSeeAdvancedInventory will be pulled from one of the permissions services, when ready
    // In Rails, checks for an overriden Retail subscription.
    if (this.currentUserData.data.shouldSeeAdvancedInventory) {
      return true;
    }
    return this.subscriptionFeatureIsEnabled(Feature.ADVANCED_INVENTORY) || this.features.isEnabled('restaurants/allow_rst_inventory_reports') || this.canUseRecipes;
  }
  set canUseAdvancedInventory(value) {
    set(this, '_canUseAdvancedInventory', value);
  }
  get canSeeGtinFeatures() {
    if (this._canSeeGtinFeatures) {
      return this._canSeeGtinFeatures;
    }
    if (this.canAllSellersUseGtin) {
      return true;
    }

    // TODO: shouldSeeAdvancedInventory will be pulled from one of the permissions services, when ready
    // In Rails, this checks for a Retail subscription and returns true if there is one.
    if (this.currentUserData.data.shouldSeeAdvancedInventory) {
      return true;
    }

    // If the seller does not have an RST or APPTs subscription, they should see GTIN features
    // (when the `canSposSellersUseGtinsByDefault` feature flag is enabled)
    if (this.canSposSellersUseGtinsByDefault && !this.isRestaurantsUser && !this.isSubscribedToAppointments) {
      return true;
    }

    // If the seller does have a RST or APPTs subscription and no RTL subscription, they should only be able
    // to see GTIN features if they have ever had an explicit subscription to Advanced Inventory
    return this.subscriptionFeatureStatus?.any(featureStatus => {
      return featureStatus.feature === Feature.ADVANCED_INVENTORY;
    }) ?? false;
  }
  set canSeeGtinFeatures(value) {
    set(this, '_canSeeGtinFeatures', value);
  }

  // These flags will end up replacing canUseAdvancedInventory to allow for more granular,
  // feature based permissioning
  get canUseRecipes() {
    return this.features.isEnabled('inventory/ingredient_tracking_m0') && (this.isPayingRstSubscriber || this.currentUserData.data.shouldSeeAdvancedInventory || this.subscriptionFeatureIsEnabled(Feature.ADVANCED_INVENTORY) || this.squareOneEligible);
  }
  get canUseSimpleCostReporting() {
    return this.isPayingRstSubscriber || this.currentUserData.data.shouldSeeAdvancedInventory || this.subscriptionFeatureIsEnabled(Feature.ADVANCED_INVENTORY);
  }
  get isInRestaurantOrRetailVFS() {
    return this.isFeatureSetActive(FeatureSetKey.RESTAURANTS) || this.isFeatureSetActive(FeatureSetKey.RETAIL);
  }

  // Compatible with both Legacy and SQ1 subscription models
  get canUseUnitCostAndVendors() {
    if (this.squareOneEligibilityUnknown) {
      // Fail open
      return true;
    } else if (this.squareOneEligible) {
      return this.isFeatureActiveAndEntitled(SaasSharedUiFeature.INVENTORY_MGMT_VENDOR_MGMT) && this.isFeatureActiveAndEntitled(SaasSharedUiFeature.INVENTORY_MGMT_MANAGE_UNIT_COSTS);
    } else {
      return this.canUseAdvancedInventory || this.canUseRecipes || this.canUseSimpleCostReporting || this.features.isEnabled('inventory/rst_inventory_features') && this.isPayingRstSubscriber;
    }
  }
  get canUseSellByVariations() {
    if (this.squareOneEligibilityUnknown) {
      // Fail open when eligibility call fails
      return true;
    } else if (this.squareOneEligible) {
      return this.isFeatureActiveAndEntitled(SaasSharedUiFeature.INVENTORY_MGMT_STOCKABLE);
    }

    // For some reason canUseAdvancedInventory has shouldSeeAdvancedInventory which comes from userData
    // set to true for Square One sellers, so add an extra check here to make sure this only applies to legacy subs
    return this.canUseAdvancedInventory || this.canUseRecipes || this.features.isEnabled('inventory/rst_inventory_features') && this.isPayingRstSubscriber;
  }
  get isSubscribingToRestaurants() {
    return this._isSubscribingToRestaurants;
  }
  set isSubscribingToRestaurants(value) {
    set(this, '_isSubscribingToRestaurants', value);
  }
  get isRestaurantsFreeTrialNoObligation() {
    if (this._isRestaurantsFreeTrialNoObligation !== undefined) {
      return this._isRestaurantsFreeTrialNoObligation;
    }
    return this.subscriptionFeatureIsStatus(Feature.RESTAURANTS, Status.FREE_TRIAL_NO_OBLIGATION) || this.isNewTierRestaurantsTrialNoObligation;
  }
  set isRestaurantsFreeTrialNoObligation(value) {
    set(this, '_isRestaurantsFreeTrialNoObligation', value);
  }
  get isNewTierRestaurantsTrialNoObligation() {
    return this.isRestaurantsPlusTrialNoObligation || this.isRestaurantsPremiumTrialNoObligation;
  }

  // New Rst tiered subscription trial states to be used for correct upsell badge
  get isRestaurantsPlusTrialNoObligation() {
    return this.subscriptionFeatureIsStatus(Feature.RESTAURANTS_PLUS, Status.FREE_TRIAL_NO_OBLIGATION) && !this.subscriptionFeatureIsStatus(Feature.RESTAURANTS_PREMIUM, Status.FREE_TRIAL_NO_OBLIGATION);
  }
  get isRestaurantsPremiumTrialNoObligation() {
    return this.subscriptionFeatureIsStatus(Feature.RESTAURANTS_PREMIUM, Status.FREE_TRIAL_NO_OBLIGATION);
  }
  get isSubscribedToRestaurantsFree() {
    return this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_FREE);
  }
  get isSubscribedToRestaurantsPlus() {
    return this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_PLUS);
  }
  get isSubscribedToRestaurantsPremium() {
    return this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_PREMIUM);
  }

  // New Rst tiered subscription user state to display legacy or new upsell sheets
  get isNewRstTierSubscriptionUser() {
    return this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_FREE) || this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_PLUS) || this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_PREMIUM);
  }
  get newRstTierSubscriptionName() {
    // Doing these in this order because each tier contains the tiers below it
    if (this.isSubscribedToRestaurantsPremium) {
      return Feature.RESTAURANTS_PREMIUM;
    } else if (this.isSubscribedToRestaurantsPlus) {
      return Feature.RESTAURANTS_PLUS;
    } else if (this.isSubscribedToRestaurantsFree) {
      return Feature.RESTAURANTS_FREE;
    }
    return null;
  }
  get isSubscribedToCombos() {
    if (this._isSubscribedToCombos !== undefined) {
      return this._isSubscribedToCombos;
    }
    if (this.squareOneEligible) {
      return this.isEntitledToFeature(SaasSharedUiFeature.ITEM_COMBOS);
    }
    return this.subscriptionFeatureIsEnabled(Feature.COMBOS);
  }
  set isSubscribedToCombos(value) {
    set(this, '_isSubscribedToCombos', value);
  }
  get isCombosFreeTrialNoObligation() {
    return this.subscriptionFeatureIsStatus(Feature.COMBOS, Status.FREE_TRIAL_NO_OBLIGATION);
  }
  get isKDSFreeTrialNoObligation() {
    // Because a Restaurants Subscription includes the KDS feature,
    // we only return true when we've subscribed to KDS free trial but
    // not a Restaurants free trial.
    if (this._isKDSFreeTrialNoObligation !== undefined) {
      return this._isKDSFreeTrialNoObligation;
    }
    return this.subscriptionFeatureIsStatus(Feature.KDS, Status.FREE_TRIAL_NO_OBLIGATION) && !this.isPayingRstSubscriber;
  }
  set isKDSFreeTrialNoObligation(value) {
    set(this, '_isKDSFreeTrialNoObligation', value);
  }
  setRSTFreeTrialJustStarted() {
    set(this, 'rstFreeTrialJustStarted', true);
  }
  get isPayingRstSubscriber() {
    if (this._isPayingRstSubscriber !== undefined) {
      return this._isPayingRstSubscriber;
    }
    return this.useRstTieredSubscriptions ? this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_PLUS) || this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_PREMIUM) || this.isSubscribedToRestaurantsLegacy : this.isSubscribedToRestaurantsLegacy;
  }
  set isPayingRstSubscriber(value) {
    set(this, '_isPayingRstSubscriber', value);
  }
  get isRestaurantsFreeTierUser() {
    if (this._isRestaurantsFreeTierUser !== undefined) {
      return this._isRestaurantsFreeTierUser;
    }
    return this.currentUserData.data.canSeeBasicRestaurantsFeatures && !this.isPayingRstSubscriber || this.isNewRstFreeTierUser;
  }
  set isRestaurantsFreeTierUser(value) {
    set(this, '_isRestaurantsFreeTierUser', value);
  }

  // RESTAURANTS_FREE feature token is included in RESTAURANTS_PLUS and RESTAURANTS_PREMIUM
  get isNewRstFreeTierUser() {
    return this.useRstTieredSubscriptions && this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_FREE) && !this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_PLUS) && !this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_PREMIUM);
  }
  get canOnboardRestaurants() {
    return this.useRstTieredSubscriptions ? !this.isPayingRstSubscriber : this.currentUserData.data.canSeeBasicRestaurantsFeatures && !this.isPayingRstSubscriber;
  }
  get isSubscribedToRestaurantsLegacy() {
    if (this._isSubscribedToRestaurantsLegacy !== undefined) {
      return this._isSubscribedToRestaurantsLegacy;
    }
    if (this.getSubscriptionFeatureStatus(Feature.RESTAURANTS)) {
      // We always prefer to respect the feature value because features are updated
      // during a dashboard session when a merchant takes action on their subscription.
      return this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS);
    } else {
      // If the RST feature does not exist, we rely on dashboard data cache value
      // (which looks at MDS) to tell us if we are subscribed to RST.
      // onboardedToRestaurantsPlus is updated when onboardToRestaurantsPro() is called, which
      // lets us show paid features without a page refresh while we wait for the RST sub2 subscription to exist.
      return this.currentUserData.data.dashboardDataHasRestaurantsSubscriptionOverride || this.onboardedToRestaurantsPlus;
    }
  }
  set isSubscribedToRestaurantsLegacy(value) {
    set(this, '_isSubscribedToRestaurantsLegacy', value);
  }

  // This method deals with describing a user subscription as a Legacy Restaurants Free user. Which means they have no RST PnP subscription or SQ1 subscription.
  get isLegacyRstFreeSubscriber() {
    return this.currentUserData.data.canSeeBasicRestaurantsFeatures && !this.isPayingRstSubscriber && !this.isNewRstFreeTierUser;
  }
  get isSubscribedToKDS() {
    if (this._isSubscribedToKDS !== undefined) {
      return this._isSubscribedToKDS;
    }

    /**
     * For SQ1 eligible sellers, check for both entitlement and correct vertical feature set activation.
     * Currently, only F&B and RTL VFSes include KDS.
     */
    if (this.squareOneEligible) {
      return this.isFeatureActiveAndEntitled(SaasSharedUiFeature.KDS);
    }
    if (this.getSubscriptionFeatureStatus(Feature.KDS)) {
      return this.subscriptionFeatureIsEnabled(Feature.KDS);
    }

    // TODO(jmckibben): RST-15839 - Solve race condition for new KDS
    //                  subscriptions within sub2.
    //                  Background: New subscriptions in sub2 are created async
    //                  and it could be the case that after we subscribe a new
    //                  KDS merchant within Dashboard that it won't be reflected
    //                  in this.subscriptionFeatureIsEnabled() which calls sub2.
    //                  RST/RTL solve this problem using a hack in MDS, which is
    //                  outlined in the Jira above.
    return false;
  }
  set isSubscribedToKDS(value) {
    set(this, '_isSubscribedToKDS', value);
  }
  get isSubscribedToFnbKiosk() {
    // @raghav: A temporary feature flag to override the kiosk subscription state.
    // Will be used by a BPO team to migrate churned legacy kiosk sellers to Omnichannel Menus.
    // This flag needs to be removed once the migration is complete.
    if (this.overrideKioskSubscription) {
      return true;
    }
    if (this._isSubscribedToFnbKiosk !== undefined) {
      return this._isSubscribedToFnbKiosk;
    }
    if (this.getSubscriptionFeatureStatus(Feature.FNB_KIOSK)) {
      return this.subscriptionFeatureIsEnabled(Feature.FNB_KIOSK);
    }
    return false;
  }
  set isSubscribedToFnbKiosk(value) {
    set(this, '_isSubscribedToFnbKiosk', value);
  }
  get wasSubscribedToFnbKiosk() {
    if (this._wasSubscribedToFnbKiosk !== undefined) {
      return this._wasSubscribedToFnbKiosk;
    }
    if (this.getSubscriptionFeatureStatus(Feature.FNB_KIOSK)) {
      return this.subscriptionFeatureIsStatus(Feature.FNB_KIOSK, Status.CANCELED);
    }
    return false;
  }
  set wasSubscribedToFnbKiosk(value) {
    set(this, '_wasSubscribedToFnbKiosk', value);
  }
  get isSubscribedToAdditionalRstPos() {
    if (this.getSubscriptionFeatureStatus(Feature.ADDITIONAL_RESTAURANTS_POS)) {
      return this.subscriptionFeatureIsEnabled(Feature.ADDITIONAL_RESTAURANTS_POS);
    }
    return false;
  }
  get isPayingAdditionalRstPosSubscriber() {
    return this.isSubscribedToAdditionalRstPos && !this.subscriptionFeatureIsStatus(Feature.ADDITIONAL_RESTAURANTS_POS, Status.FREE_TRIAL_NO_OBLIGATION);
  }
  get isPayingMobileRstSubscriber() {
    return this.isSubscribedToRstMobile && !this.subscriptionFeatureIsStatus(Feature.RESTAURANTS_MOBILE, Status.FREE_TRIAL_NO_OBLIGATION);
  }
  get isPayingKdsSubscriber() {
    return this.isSubscribedToKDS && !this.subscriptionFeatureIsStatus(Feature.KDS, Status.FREE_TRIAL_NO_OBLIGATION);
  }
  get isSubscribedToRstMobile() {
    if (this.getSubscriptionFeatureStatus(Feature.RESTAURANTS_MOBILE)) {
      return this.subscriptionFeatureIsEnabled(Feature.RESTAURANTS_MOBILE);
    }
    return false;
  }
  get wasSubscribedToRestaurants() {
    return this.wasSubscribedToRestaurantsLegacy || this.wasSubscribedToNewPaidRestaurantTiers;
  }
  get wasSubscribedToRestaurantsLegacy() {
    return this.subscriptionFeatureIsStatus(Feature.RESTAURANTS, Status.CANCELED);
  }
  get wasSubscribedToNewPaidRestaurantTiers() {
    return this.subscriptionFeatureIsStatus(Feature.RESTAURANTS_PLUS, Status.CANCELED) || this.subscriptionFeatureIsStatus(Feature.RESTAURANTS_PREMIUM, Status.CANCELED);
  }
  // NB(jlintern): this is defined as a oneWay because tests set it directly
  // Also includes Square One subscribers with Restaurant features
  get canSeeAutoGratuitiesReporting() {
    // Square One subscribers with active or previously active Restaurant feature set
    if (this.squareOneEligible) {
      if (this.isFeatureSetActive(FeatureSetKey.RESTAURANTS) || this.wasFeatureSetActive(FeatureSetKey.RESTAURANTS)) {
        return true;
      }
    }
    // Legacy Restaurant Plus/Premium subscribers or previously subscribed
    return this.isOrWasSubscribedToRestaurants;
  }
  get isSubscribedToEmployeeManagement() {
    if (this._isSubscribedToEmployeeManagement !== undefined) {
      return this._isSubscribedToEmployeeManagement;
    }
    return Boolean(this.canAccessSquareOne ? this.isEntitledToFeature(SaasSharedUiFeature.STAFF_UNLIMITED_CUSTOM_PERMISSION_SETS) && this.isEntitledToFeature(SaasSharedUiFeature.STAFF_TEAM_MEMBER_BADGES) : this.subscriptionFeatureIsEnabled(Feature.EMPLOYEE_MANAGEMENT));
  }
  set isSubscribedToEmployeeManagement(value) {
    set(this, '_isSubscribedToEmployeeManagement', value);
  }
  get isSubscribedToTeamMemberOnboarding() {
    return this.canAccessSquareOne ? this.isEntitledToFeature(SaasSharedUiFeature.STAFF_NEW_HIRE_ONBOARDING) : this.subscriptionFeatureIsEnabled(Feature.TEAM_MEMBER_ONBOARDING);
  }
  get isSquareOneSchedulingFreeTrial() {
    return this.canAccessSquareOne && this.isInTrialForFeature(SaasSharedUiFeature.STAFF_SCHEDULING);
  }
  get isSquareOneTimecardsFreeTrial() {
    return this.canAccessSquareOne && this.isInTrialForFeature(SaasSharedUiFeature.STAFF_TIMECARDS);
  }

  // Payroll
  get isSubscribedToPayroll() {
    return this.subscriptionFeatureIsEnabled(Feature.PAYROLL);
  }

  // === START APPOINTMENTS ===
  /**
   * @deprecated
   * Only external usage is in Processing Fees page for legacy sellers
   */
  get isSubscribedToAppointmentsFree() {
    return this.subscriptionFeatureIsEnabled(Feature.APPOINTMENTS_FREE) && !this.subscriptionFeatureIsEnabled(Feature.APPOINTMENTS_PLUS);
  }
  get isSubscribedToAppointments() {
    if (this._isSubscribedToAppointments !== undefined) {
      return this._isSubscribedToAppointments;
    }
    if (this.canAccessSquareOne) {
      return this.isFeatureSetActive(FeatureSetKey.APPOINTMENTS);
    } else {
      return this.hasAppointmentsFeature(AppointmentsFeatureId.APPOINTMENTS_FREE) || this.hasAppointmentsFeature(AppointmentsFeatureId.APPOINTMENTS_PLUS) || this.hasAppointmentsFeature(AppointmentsFeatureId.APPOINTMENTS_PREMIUM);
    }
  }
  set isSubscribedToAppointments(value) {
    set(this, '_isSubscribedToAppointments', value);
  }
  async hasAppointmentsAccount() {
    if (this.canAccessSquareOne) {
      return this.isFeatureSetActive(FeatureSetKey.APPOINTMENTS);
    } else {
      try {
        const response = await jsonGet('/appointments/api/users/account_status');
        set(this, '_hasAppointmentsAccount', response.has_account);
        return response.has_account;
      } catch (error) {
        error.name = 'Failed to get appointments account status';
        Sentry.captureException(error);
        return false;
      }
    }
  }
  async fetchAppointmentsFeaturesUsingFeaturamaOnly({
    merchantToken,
    merchantCountryCode,
    forceRefresh = false
  }) {
    const hasAppointmentsAccount = await this.hasAppointmentsAccount();
    if (this.appointmentsActiveFeatures && !forceRefresh) {
      // No need to fetch again; return cached results.
      return;
    }
    const activeFeatures = Object.keys(AppointmentsFeatureId).map(featureName => {
      const feature = SaasSharedUiFeature[featureName];
      if (this.isEntitledToFeature(feature)) {
        return featureName;
      }
      return null;
    }).filter(Boolean);

    // We still need to call `/GetSubscriptions` for legacy sellers to populate internal
    // `appointments-subscriptions` fields, allowing things like `planGroup` to be consumed.
    // `/GetSubscriptions` errors for SQ1 sellers, so we skip it for them in all cases.
    if (this.squareOneIneligible && !this.squareOneEligibilityUnknown) {
      if (this.appointmentsSubscription.subscriptionIsFetched && !forceRefresh) {
        // No need to fetch again; return cached results.
        return;
      }
      await this.appointmentsSubscription.fetch({
        merchantToken,
        merchantCountryCode,
        hasAppointmentsAccount,
        forceRefresh
      });
    }
    set(this, 'appointmentsActiveFeatures', A(activeFeatures));
  }
  async fetchAppointmentsFeaturesUsingFeaturamaOrGetSubscription({
    merchantToken,
    merchantCountryCode,
    forceRefresh = false
  }) {
    const hasAppointmentsAccount = await this.hasAppointmentsAccount();
    let activeFeatures;
    if (this.squareOneEligible || this.squareOneEligibilityUnknown) {
      if (this.appointmentsActiveFeatures && !forceRefresh) {
        // No need to fetch again; return cached results.
        return;
      }

      // For SQ1-eligible sellers, we rely on Featurama for activeFeatures, rather than GetSubscriptions.
      activeFeatures = Object.keys(AppointmentsFeatureId).map(featureName => {
        const feature = SaasSharedUiFeature[featureName];
        if (this.isEntitledToFeature(feature)) {
          return featureName;
        }
        return null;
      }).filter(Boolean);
    } else {
      if (this.appointmentsSubscription.subscriptionIsFetched && this.appointmentsActiveFeatures && !forceRefresh) {
        // No need to fetch again; return cached results.
        return;
      }

      // This populates internal appointments-subscriptions fields, allowing things like
      // planGroup to be consumed for legacy sellers.
      activeFeatures = await this.appointmentsSubscription.fetch({
        merchantToken,
        merchantCountryCode,
        hasAppointmentsAccount,
        forceRefresh
      });
    }
    set(this, 'appointmentsActiveFeatures', A(activeFeatures));
  }

  // When `square_one_web/featurama_calls_enabled` is fully rolled out, we should delete
  // this function and `fetchAppointmentsFeaturesUsingFeaturamaOrGetSubscription()`, then
  // rename `fetchAppointmentsFeaturesUsingFeaturamaOnly()` to `fetchAppointmentsFeatures`.
  async fetchAppointmentsFeatures({
    merchantToken,
    merchantCountryCode,
    forceRefresh = false
  }) {
    const params = {
      merchantToken,
      merchantCountryCode,
      forceRefresh
    };
    this.featuramaCallsEnabled ? await this.fetchAppointmentsFeaturesUsingFeaturamaOnly(params) : await this.fetchAppointmentsFeaturesUsingFeaturamaOrGetSubscription(params);
  }
  hasAppointmentsFeatureUsingFeaturamaOnly(feature) {
    return this.isEntitledToFeature(SaasSharedUiFeature[AppointmentsFeatureId[feature]]);
  }

  /**
   * An Appointments seller can get its feature entitlement from one of three sources:
   *
   * 1. `/BulkRetrieveFeatureStatuses` (i.e. Featurama)
   *   - Updated via observer on `featurama.getFeatureStatuses`
   *   - Populated in `featuramaFeatureStatuses`
   * 2. `/current-user-data`
   *   - Updated via `updateSubscriptionFeatures` (initialized by `currentUserData` service)
   *   - Populated in `subscriptionFeatureStatus`
   * 3. `/GetSubscriptions` (i.e. legacy Appointments subscription)
   *   - Updated via `fetchAppointmentsFeatures`
   *   - Populated in `appointmentsActiveFeatures`
   *
   * @param feature
   */
  hasAppointmentsFeatureUsingFeaturamaOrGetSubscription(feature) {
    if (this.squareOneEligible) {
      // Feature entitled via Featurama
      return this.isEntitledToFeature(SaasSharedUiFeature[AppointmentsFeatureId[feature]]);
    } else {
      // Feature entitled via legacy sub2 or Appointments subscription
      return this.subscriptionFeatureIsEnabled(feature.toString()) || (this.appointmentsActiveFeatures?.includes(feature) ?? false);
    }
  }

  // When `square_one_web/featurama_calls_enabled` is fully rolled out, we should delete
  // this function and `hasAppointmentsFeatureUsingFeaturamaOrGetSubscription()`, then
  // rename `hasAppointmentsFeatureUsingFeaturamaOnly()` to `hasAppointmentsFeature`.
  hasAppointmentsFeature(feature) {
    return this.featuramaCallsEnabled ? this.hasAppointmentsFeatureUsingFeaturamaOnly(feature) : this.hasAppointmentsFeatureUsingFeaturamaOrGetSubscription(feature);
  }
  get isSubscribedToEcomFree() {
    return this.subscriptionFeatureIsEnabled(Feature.ECOM_FREE) && !this.subscriptionFeatureIsEnabled(Feature.ECOM_PLUS) && !this.subscriptionFeatureIsEnabled(Feature.ECOM_PREMIUM);
  }
  get wasSubscribedToEcomPlus() {
    if (this._wasSubscribedToEcomPlus !== undefined) {
      return this._wasSubscribedToEcomPlus;
    }
    return this.subscriptionFeatureIsStatus(Feature.ECOM_PLUS, Status.CANCELED);
  }
  set wasSubscribedToEcomPlus(value) {
    set(this, '_wasSubscribedToEcomPlus', value);
  }
  get isPayingEcomSubscriber() {
    if (this._isPayingEcomSubscriber !== undefined) {
      return this._isPayingEcomSubscriber;
    }
    return this.subscriptionFeatureIsEnabled(Feature.ECOM_PLUS) || this.subscriptionFeatureIsEnabled(Feature.ECOM_PREMIUM);
  }
  set isPayingEcomSubscriber(value) {
    set(this, '_isPayingEcomSubscriber', value);
  }

  // Reporting
  get canUseCategoryRollups() {
    if (this.squareOneEligibleOrUnknown) {
      return this.isEntitledToFeature(SaasSharedUiFeature.FNB_CATEGORY_ROLLUPS);
    } else {
      return this.hasAppointmentsFeature(AppointmentsFeatureId.APPOINTMENTS_PLUS) || this.isPayingRstSubscriber;
    }
  }
  get isSubscribedToBlockedBooking() {
    if (this._isSubscribedToBlockedBooking !== undefined) {
      return this._isSubscribedToBlockedBooking;
    }
    return this.subscriptionFeatureIsEnabled(Feature.APPOINTMENTS_CUSTOMER_BLOCKING);
  }
  /**
   * Retrieves the feature statuses from Featurama.
   *
   * If the query fails:
   * - The error state will be set on featuramaFeatureStatusesResult
   * - Returns the current state of featuramaFeatureStatusesResult.data
   *
   * If called while a refresh is in progress:
   * - Returns the cached data immediately from featuramaFeatureStatusesResult.data
   * - Does not wait for the refresh to complete
   */
  async retrieveFeatureStatuses() {
    this.setupFeatureStatusesQueryObservers();

    // Catch error when throwOnError is true
    // Error state will be set on featuramaFeatureStatusesResult
    try {
      await this.emberQuery.readQuery(this.queryDefs.bulkRetrieveFeatureStatuses);
      // eslint-disable-next-line no-empty
    } catch {}
    return this.featuramaFeatureStatusesResult;
  }

  /**
   * Retrieves the feature set statuses from Featurama.
   *
   * If the query fails:
   * - The error state will be set on featureSetStatusResult
   * - Returns the current state of featureSetStatusResult.data
   *
   * If called while a refresh is in progress:
   * - Returns the cached data immediately from featureSetStatusResult.data
   * - Does not wait for the refresh to complete
   */
  async retrieveFeatureSetStatuses() {
    this.setupFeatureStatusesQueryObservers();

    // Catch error when throwOnError is true
    // Error state will be set on featureSetStatusResult
    try {
      await this.emberQuery.readQuery(this.queryDefs.bulkRetrieveFeatureSetStatuses);
      // eslint-disable-next-line no-empty
    } catch {}
    return this.featureSetStatusResult;
  }
  get featuramaFeatureStatuses() {
    const data = this.featuramaFeatureStatusesResult.data;
    return featureResponseToFeatureMap(data?.featureStatuses ?? []);
  }
  get featureSetStatusMap() {
    const data = this.featureSetStatusResult.data;
    return featureSetResponseToFeatureSetMap(data?.featureSetStatuses ?? []);
  }

  /**
   * @deprecated
   */
  get canAccessSquareOne() {
    return Boolean(this.squareOneEligibility?.eligible);
  }
  get squareOneEligible() {
    return this.squareOneEligibility?.eligible === true;
  }
  get squareOneEligibilityUnknown() {
    return this.squareOneEligibility?.eligible === undefined;
  }
  get squareOneIneligible() {
    return this.squareOneEligibility?.eligible === false;
  }
  get squareOneEligibleOrUnknown() {
    return this.squareOneEligible || this.squareOneEligibilityUnknown;
  }
  get squareOneIneligibleOrUnknown() {
    return this.squareOneIneligible || this.squareOneEligibilityUnknown;
  }
  defineFeatureGetters(feature) {
    if (typeof feature === 'string') {
      return;
    }
    const featureKeyConstantCase = SaasSharedUiFeature[feature];
    const featureKeyPascalCase = toPascalCase(featureKeyConstantCase);
    Object.defineProperties(this, {
      [`isEntitledTo${featureKeyPascalCase}`]: {
        enumerable: true,
        get() {
          return this.isEntitledToFeature(feature);
        }
      },
      [`isInTrialFor${featureKeyPascalCase}`]: {
        enumerable: true,
        get() {
          return this.isInTrialForFeature(feature);
        }
      },
      [`shouldUpsell${featureKeyPascalCase}`]: {
        enumerable: true,
        get() {
          return this.shouldUpsellFeature(feature);
        }
      },
      [`shouldLegacyUpsell${featureKeyPascalCase}`]: {
        enumerable: true,
        get() {
          return this.shouldLegacyUpsellFeature(feature);
        }
      }
    });
  }
  getFeaturamaFeatureStatus(feature) {
    return this.featuramaFeatureStatuses?.[feature]?.subscriptionStatus;
  }
  getFeatureSetStatus(featureSet) {
    return this.featureSetStatusMap?.[featureSet];
  }
  isEntitledToFeature(feature) {
    return Boolean(this.getFeaturamaFeatureStatus(feature)?.isEntitled);
  }
  isFeatureSetActive(featureSetKey) {
    return Boolean(this.getFeatureSetStatus(featureSetKey)?.isActive);
  }
  wasFeatureSetActive(featureSetKey) {
    const status = this.getFeatureSetStatus(featureSetKey);
    return status?.activationStatus === ActivationStatus.DEACTIVATED;
  }
  isFeatureActive(feature) {
    return Boolean(this.featuramaFeatureStatuses?.[feature]?.activationStatus?.isActive);
  }
  isFeatureActiveAndEntitled(feature) {
    return this.isFeatureActive(feature) && this.isEntitledToFeature(feature);
  }
  isInTrialForFeature(feature) {
    return Boolean(this.getFeaturamaFeatureStatus(feature)?.isInTrial);
  }
  shouldUpsellFeature(feature) {
    if (!this.canAccessSquareOne) {
      return false;
    }
    return !this.isEntitledToFeature(feature);
  }
  shouldLegacyUpsellFeature(feature) {
    if (this.canAccessSquareOne) {
      return false;
    }
    return !this.isEntitledToFeature(feature);
  }
  isPayingLegacyRstSubscriberOrSquareOneEntitledToFeature(feature) {
    if (this.squareOneEligibleOrUnknown) {
      return this.isEntitledToFeature(feature);
    } else {
      return this.isPayingRstSubscriber;
    }
  }
  // === END SQUARE ONE ===
}, _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "emberQuery", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "squareOneEligibility", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, "useRstTieredSubscriptions", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class3.prototype, "canSposSellersUseGtinsByDefault", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class3.prototype, "canAllSellersUseGtin", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class3.prototype, "featuramaCallsEnabled", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class3.prototype, "overrideKioskSubscription", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class3.prototype, "subscriptionFeatureStatus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class3.prototype, "appointmentsActiveFeatures", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class3.prototype, "hasLoadedFeaturamaFeatureFlag", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class3.prototype, "featureStatusesQueryObserver", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class3.prototype, "featureSetStatusesQueryObserver", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, "setupFeatureStatusesQueryObservers", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "setupFeatureStatusesQueryObservers"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "cleanUpFeatureStatusesQueryObservers", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "cleanUpFeatureStatusesQueryObservers"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "setFeaturamaFeatureStatuses", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "setFeaturamaFeatureStatuses"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "setFeaturamaSetStatuses", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "setFeaturamaSetStatuses"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToMarketing", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToMarketing"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToMarketingSms", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToMarketingSms"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isMarketingPaused", [_dec6], Object.getOwnPropertyDescriptor(_class3.prototype, "isMarketingPaused"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToLoyalty", [_dec7], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToLoyalty"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRestaurantsUser", [_dec8], Object.getOwnPropertyDescriptor(_class3.prototype, "isRestaurantsUser"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribingToRetail", [_dec9], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribingToRetail"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToRetailPlus", [_dec10], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToRetailPlus"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToRetail", [_dec11], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToRetail"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToRetailFree", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToRetailFree"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "canRetailerSeeItemOptions", [_dec12], Object.getOwnPropertyDescriptor(_class3.prototype, "canRetailerSeeItemOptions"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRetailFreeTrialNoObligation", [_dec13], Object.getOwnPropertyDescriptor(_class3.prototype, "isRetailFreeTrialNoObligation"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRetailFreeTrial", [_dec14], Object.getOwnPropertyDescriptor(_class3.prototype, "isRetailFreeTrial"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRetailFree", [_dec15], Object.getOwnPropertyDescriptor(_class3.prototype, "isRetailFree"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRetailPaused", [_dec16], Object.getOwnPropertyDescriptor(_class3.prototype, "isRetailPaused"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRetailDelinquent", [_dec17], Object.getOwnPropertyDescriptor(_class3.prototype, "isRetailDelinquent"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRetailFreeTrialExpired", [_dec18], Object.getOwnPropertyDescriptor(_class3.prototype, "isRetailFreeTrialExpired"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRetailPending", [_dec19], Object.getOwnPropertyDescriptor(_class3.prototype, "isRetailPending"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRetailPresale", [_dec20], Object.getOwnPropertyDescriptor(_class3.prototype, "isRetailPresale"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "canUseAdvancedInventory", [_dec21], Object.getOwnPropertyDescriptor(_class3.prototype, "canUseAdvancedInventory"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "canSeeGtinFeatures", [_dec22], Object.getOwnPropertyDescriptor(_class3.prototype, "canSeeGtinFeatures"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribingToRestaurants", [_dec23], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribingToRestaurants"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRestaurantsFreeTrialNoObligation", [_dec24], Object.getOwnPropertyDescriptor(_class3.prototype, "isRestaurantsFreeTrialNoObligation"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isNewTierRestaurantsTrialNoObligation", [_dec25], Object.getOwnPropertyDescriptor(_class3.prototype, "isNewTierRestaurantsTrialNoObligation"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRestaurantsPlusTrialNoObligation", [_dec26], Object.getOwnPropertyDescriptor(_class3.prototype, "isRestaurantsPlusTrialNoObligation"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRestaurantsPremiumTrialNoObligation", [_dec27], Object.getOwnPropertyDescriptor(_class3.prototype, "isRestaurantsPremiumTrialNoObligation"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToRestaurantsFree", [_dec28], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToRestaurantsFree"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToRestaurantsPlus", [_dec29], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToRestaurantsPlus"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToRestaurantsPremium", [_dec30], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToRestaurantsPremium"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isNewRstTierSubscriptionUser", [_dec31], Object.getOwnPropertyDescriptor(_class3.prototype, "isNewRstTierSubscriptionUser"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "newRstTierSubscriptionName", [_dec32], Object.getOwnPropertyDescriptor(_class3.prototype, "newRstTierSubscriptionName"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToCombos", [_dec33], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToCombos"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isCombosFreeTrialNoObligation", [_dec34], Object.getOwnPropertyDescriptor(_class3.prototype, "isCombosFreeTrialNoObligation"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isKDSFreeTrialNoObligation", [_dec35], Object.getOwnPropertyDescriptor(_class3.prototype, "isKDSFreeTrialNoObligation"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isPayingRstSubscriber", [_dec36], Object.getOwnPropertyDescriptor(_class3.prototype, "isPayingRstSubscriber"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isRestaurantsFreeTierUser", [_dec37], Object.getOwnPropertyDescriptor(_class3.prototype, "isRestaurantsFreeTierUser"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isNewRstFreeTierUser", [_dec38], Object.getOwnPropertyDescriptor(_class3.prototype, "isNewRstFreeTierUser"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToRestaurantsLegacy", [_dec39], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToRestaurantsLegacy"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isLegacyRstFreeSubscriber", [_dec40], Object.getOwnPropertyDescriptor(_class3.prototype, "isLegacyRstFreeSubscriber"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToKDS", [_dec41], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToKDS"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToFnbKiosk", [_dec42], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToFnbKiosk"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "wasSubscribedToFnbKiosk", [_dec43], Object.getOwnPropertyDescriptor(_class3.prototype, "wasSubscribedToFnbKiosk"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToAdditionalRstPos", [_dec44], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToAdditionalRstPos"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToRstMobile", [_dec45], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToRstMobile"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "wasSubscribedToRestaurants", [_dec46], Object.getOwnPropertyDescriptor(_class3.prototype, "wasSubscribedToRestaurants"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "wasSubscribedToRestaurantsLegacy", [_dec47], Object.getOwnPropertyDescriptor(_class3.prototype, "wasSubscribedToRestaurantsLegacy"), _class3.prototype), _descriptor21 = _applyDecoratedDescriptor(_class3.prototype, "isOrWasSubscribedToRestaurants", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, "wasSubscribedToNewPaidRestaurantTiers", [_dec49], Object.getOwnPropertyDescriptor(_class3.prototype, "wasSubscribedToNewPaidRestaurantTiers"), _class3.prototype), _descriptor22 = _applyDecoratedDescriptor(_class3.prototype, "isOrWasSubscribedToNewPaidRestaurantsTiers", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, "canSeeAutoGratuitiesReporting", [_dec51], Object.getOwnPropertyDescriptor(_class3.prototype, "canSeeAutoGratuitiesReporting"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToEmployeeManagement", [_dec52], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToEmployeeManagement"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToPayroll", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToPayroll"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToAppointmentsFree", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToAppointmentsFree"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToAppointments", [_dec53], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToAppointments"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToEcomFree", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToEcomFree"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "wasSubscribedToEcomPlus", [_dec54], Object.getOwnPropertyDescriptor(_class3.prototype, "wasSubscribedToEcomPlus"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isPayingEcomSubscriber", [_dec55], Object.getOwnPropertyDescriptor(_class3.prototype, "isPayingEcomSubscriber"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "canUseCategoryRollups", [_dec56], Object.getOwnPropertyDescriptor(_class3.prototype, "canUseCategoryRollups"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "isSubscribedToBlockedBooking", [_dec57], Object.getOwnPropertyDescriptor(_class3.prototype, "isSubscribedToBlockedBooking"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "featuramaFeatureStatuses", [_dec58], Object.getOwnPropertyDescriptor(_class3.prototype, "featuramaFeatureStatuses"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "featureSetStatusMap", [_dec59], Object.getOwnPropertyDescriptor(_class3.prototype, "featureSetStatusMap"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "defineFeatureGetters", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "defineFeatureGetters"), _class3.prototype), _class3);
export { UserSubscriptions as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.